import { useSelector } from 'react-redux';

import Global from '../../../../../../store/global-selectors';
import { useIsSellerOnFeatureGatedPlanProfile } from '../../../../../../feature-gates/use-is-seller-on-feature-gated-plan-profile';

/**
 * Users can not change their custom shipment volume through the UI. If one is set for them and they want to
 * change plans, we need to send a flag in the request to retain the custom shipment volume. This works when changing
 * plans and keeping the custom shipment volume or when downgrading the custom shipment volume on the same or lower
 * plan, and reverting back to the custom shipment volume while the change is still pending.
 * @param {number} desiredShipmentLimit
 * @returns {boolean}
 */
export const useShouldRestoreCustomShipmentVolume = (desiredShipmentLimit) => {
  const isNewLineupEnabledForSeller = useIsSellerOnFeatureGatedPlanProfile();
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const { isCustom, limit } = subscriptionData?.currentBillingPlan?.shipmentLimit || {};

  return isNewLineupEnabledForSeller && isCustom && limit === desiredShipmentLimit;
};
